<div *transloco="let t" class="empty-feed-root">
  <div class="empty-feed-icon">
    <mat-icon class="icon">{{ icon }}</mat-icon>
  </div>
  <app-header class="empty-feed-header">
    {{ header }}
  </app-header>
  <app-paragraph class="empty-feed-text">
    {{ text }}
  </app-paragraph>
</div>
